import React from "react";

function SuccessPage() {
  return (
    <>
      <div className="container text-center py-5 min-vh-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-9 col-md-8 col-lg-6 col-xl-4">
            <div
              className="card mt-5 shadow-lg"
              style={{
                maxWidth: "48rem",
                backgroundColor: "#38E54D",
                borderRadius: "15px",
              }}
            >
              <i
                className="fa-solid fa-circle-check text-dark mt-5"
                style={{ fontSize: "4rem" }}
              ></i>

              <div className="card-body text-center mb-5">
                <h2 className="card-text mt-3">Thank You!</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SuccessPage;
